import React, { useState, useRef, useEffect } from "react"
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Button,
  Row,
  Col,
  Alert,
  Badge,
  Collapse,
  Label,
  UncontrolledTooltip,
} from "reactstrap"
import SimpleBar from "simplebar-react"
import { CreateCPSComment } from "helpers/backend_helper"

const CPSComments = ({ entry, reload }) => {
  const [newComment, setNewComment] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showOrderForm, setShowOrderForm] = useState(false)
  const [showStockForm, setShowStockForm] = useState(false)
  const [file, setFile] = useState()
  const [orderForm, setOrderForm] = useState({
    quantity: "",
    deliveryDate: "",
    notes: "",
  })
  const [stockForm, setStockForm] = useState({
    rawStock: "",
  })

  const simpleBarRef = useRef()

  // Demo comments data based on entry status
  const getDemoComments = status => {
    const baseComments = [
      {
        id: 1,
        text: "Request received and under review. We will provide an offer within the next business days.",
        username: "CPS Team",
        type: "(Lab)",
        timestamp: entry?.dateCreated,
        fileURL: null,
      },
    ]

    switch (status) {
      case "CPS Offer":
        return [
          ...baseComments,
          {
            id: 2,
            text: "Offer uploaded for review. Please check the pricing and timeline.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-15 14:15",
            fileURL: null,
          },
        ]
      case "Customer Decision":
        return [
          ...baseComments,
          {
            id: 2,
            text: "Offer uploaded for review. Please check the pricing and timeline.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-15 14:15",
            fileURL: null,
          },
          {
            id: 3,
            text: "The pricing looks good. When can we expect the components to be ready?",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-15 16:45",
            fileURL: null,
          },
        ]
      case "Goods Shipped":
        return [
          ...baseComments,
          {
            id: 2,
            text: "Offer uploaded for review. Please check the pricing and timeline.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-15 14:15",
            fileURL: null,
          },
          {
            id: 3,
            text: "The pricing looks good. When can we expect the components to be ready?",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-15 16:45",
            fileURL: null,
          },
          {
            id: 4,
            text: "Components shipped with tracking number DHL-123456789",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-18 09:30",
            fileURL: null,
          },
        ]
      case "Goods Received":
        return [
          ...baseComments,
          {
            id: 2,
            text: "Offer uploaded for review. Please check the pricing and timeline.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-15 14:15",
            fileURL: null,
          },
          {
            id: 3,
            text: "The pricing looks good. When can we expect the components to be ready?",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-15 16:45",
            fileURL: null,
          },
          {
            id: 4,
            text: "Components shipped with tracking number DHL-123456789",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-18 09:30",
            fileURL: null,
          },
          {
            id: 5,
            text: "Components received and inspected. All items in good condition.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-19 11:15",
            fileURL: null,
          },
        ]
      case "Sample Production":
        return [
          ...baseComments,
          {
            id: 2,
            text: "Offer uploaded for review. Please check the pricing and timeline.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-15 14:15",
            fileURL: null,
          },
          {
            id: 3,
            text: "The pricing looks good. When can we expect the components to be ready?",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-15 16:45",
            fileURL: null,
          },
          {
            id: 4,
            text: "Components shipped with tracking number DHL-123456789",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-18 09:30",
            fileURL: null,
          },
          {
            id: 5,
            text: "Components received and inspected. All items in good condition.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-19 11:15",
            fileURL: null,
          },
          {
            id: 6,
            text: "Sample production started. Expected completion in 3-5 days.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-20 08:00",
            fileURL: null,
          },
        ]
      case "Sample Approval":
        return [
          ...baseComments,
          {
            id: 2,
            text: "Offer uploaded for review. Please check the pricing and timeline.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-15 14:15",
            fileURL: null,
          },
          {
            id: 3,
            text: "The pricing looks good. When can we expect the components to be ready?",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-15 16:45",
            fileURL: null,
          },
          {
            id: 4,
            text: "Components shipped with tracking number DHL-123456789",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-18 09:30",
            fileURL: null,
          },
          {
            id: 5,
            text: "Components received and inspected. All items in good condition.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-19 11:15",
            fileURL: null,
          },
          {
            id: 6,
            text: "Sample production started. Expected completion in 3-5 days.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-20 08:00",
            fileURL: null,
          },
          {
            id: 7,
            text: "Sample completed and shipped. Please review and provide feedback.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-23 14:30",
            fileURL: null,
          },
        ]
      case "Production":
        return [
          ...baseComments,
          {
            id: 2,
            text: "Offer uploaded for review. Please check the pricing and timeline.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-15 14:15",
            fileURL: null,
          },
          {
            id: 3,
            text: "The pricing looks good. When can we expect the components to be ready?",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-15 16:45",
            fileURL: null,
          },
          {
            id: 4,
            text: "Components shipped with tracking number DHL-123456789",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-18 09:30",
            fileURL: null,
          },
          {
            id: 5,
            text: "Components received and inspected. All items in good condition.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-19 11:15",
            fileURL: null,
          },
          {
            id: 6,
            text: "Production started. Expected completion in 2 weeks.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-25 09:00",
            fileURL: null,
          },
          {
            id: 7,
            text: "For annual quantity: Please specify quantity and desired delivery date for next batch.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-26 10:00",
            fileURL: null,
          },
        ]
      case "Stock Management":
        return [
          ...baseComments,
          {
            id: 2,
            text: "Offer uploaded for review. Please check the pricing and timeline.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-15 14:15",
            fileURL: null,
          },
          {
            id: 3,
            text: "The pricing looks good. When can we expect the components to be ready?",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-15 16:45",
            fileURL: null,
          },
          {
            id: 4,
            text: "Components shipped with tracking number DHL-123456789",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-18 09:30",
            fileURL: null,
          },
          {
            id: 5,
            text: "Components received and inspected. All items in good condition.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-19 11:15",
            fileURL: null,
          },
          {
            id: 6,
            text: "Production started. Expected completion in 2 weeks.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-25 09:00",
            fileURL: null,
          },
          {
            id: 7,
            text: "For annual quantity: Please specify quantity and desired delivery date for next batch.",
            username: "CPS Team",
            type: "(Lab)",
            timestamp: "2025-01-26 10:00",
            fileURL: null,
          },

          {
            id: 8,
            text: "I need 2000 pcs for next month. Can you start production?",
            username: entry?.customer?.name || "Customer",
            type: "(Customer)",
            timestamp: "2025-01-27 14:30",
            fileURL: null,
          },
        ]
      default:
        return baseComments
    }
  }

  // Use real API comments if available, otherwise fall back to demo comments
  const comments =
    entry?.comments && entry.comments.length > 0
      ? entry.comments.map(comment => ({
          id: comment.id,
          text: comment.text,
          username: comment.username || "Unknown User",
          type: comment.type || "(Lab)",
          timestamp: comment.timestamp || comment.dateCreated,
          fileURL: comment.fileURL,
        }))
      : getDemoComments(entry?.status)

  const handleSubmitComment = async e => {
    e.preventDefault()
    if (!newComment.trim() && !file) return

    setIsSubmitting(true)

    try {
      const commentData = {
        cpsRequestID: entry.id,
        text: newComment,
        type: "(Lab)", // Default to Lab comment, could be made dynamic
        fileURL: file ? URL.createObjectURL(file) : null,
      }

      await CreateCPSComment(commentData)

      setNewComment("")
      setFile()
      setIsSubmitting(false)

      // Reload the data to show the new comment
      if (reload) {
        reload()
      }
    } catch (error) {
      console.error("Error submitting comment:", error)
      setIsSubmitting(false)
    }
  }

  const handleSubmitOrder = async e => {
    e.preventDefault()
    if (!orderForm.quantity || !orderForm.deliveryDate) return

    setIsSubmitting(true)

    setTimeout(() => {
      setIsSubmitting(false)
      setOrderForm({ quantity: "", deliveryDate: "", notes: "" })
      setShowOrderForm(false)
      alert("Order request submitted via chat!")
    }, 1500)
  }

  const handleSubmitStock = async e => {
    e.preventDefault()
    if (!stockForm.rawStock) return

    setIsSubmitting(true)

    setTimeout(() => {
      setIsSubmitting(false)
      setStockForm({ rawStock: "" })
      setShowStockForm(false)
      alert("Stock levels updated via chat!")
    }, 1500)
  }

  const handleFileChange = event => {
    event.preventDefault()
    setFile(event.target.files[0])
    event.target.value = ""
  }

  useEffect(() => {
    // This function scrolls the content to the bottom
    const scrollToBottom = () => {
      const scrollElement = simpleBarRef.current.getScrollElement()
      scrollElement.scrollTop = scrollElement.scrollHeight
    }

    // Call scrollToBottom whenever you need, e.g., after adding a comment
    scrollToBottom()
  }, []) // You might want to add dependencies here, like the comments list

  const formatDate = dateString => {
    return new Date(dateString).toLocaleString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const isProductionActive =
    entry?.status === "Production" || entry?.status === "Stock Management"
  const isOneTimeNeed = entry?.needType === "one-time"

  return (
    <Card>
      <CardBody>
        <h5 className="mb-4">Public Chat</h5>

        <SimpleBar ref={simpleBarRef} style={{ maxHeight: "300px" }}>
          <div>
            <ul className="list-group list-group-flush">
              {comments.map((comment, index) => (
                <li className="list-group-item py-3" key={index}>
                  <div className="d-flex">
                    <div className="avatar-xs me-3">
                      <div className="avatar-title rounded-circle bg-light text-primary">
                        <i className="bx bxs-user"></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14 mb-1">
                        {comment.username} {comment.type}
                        <small className="text-muted float-end">
                          {formatDate(comment.timestamp)}
                        </small>
                      </h5>
                      <p className="text-muted">{comment.text}</p>
                      {comment.fileURL && (
                        <Row className="">
                          <Col className="col-auto px-0">
                            <i className="bx bxs-file ms-1 font-size-18" />
                          </Col>
                          <Col className="col-auto ">
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={comment.fileURL}
                              className="text-decoration-underline"
                            >
                              {comment.fileURL && comment.fileURL !== "#"
                                ? new URL(comment.fileURL).pathname
                                    .split("/")
                                    .pop()
                                : "Document"}
                            </a>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </SimpleBar>

        {file && (
          <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete mx-3">
            <div className="p-2">
              <Row className="align-items-center">
                <Col className="col-auto">
                  <i className="bx bxs-file ms-4 font-size-20" />
                </Col>
                <Col>
                  <a className="text-muted font-weight-bold">{file.name}</a>
                  <p className="mb-0">
                    <strong>{file.formattedSize}</strong>
                  </p>
                </Col>
                <Col className="text-end">
                  <button
                    type="button"
                    id="close_toggle"
                    className="btn btn-sm btn-link ms-3 fs-18 text-danger"
                    onClick={() => setFile()}
                  >
                    <i className="bx bx-x align-middle font-size-24"></i>
                  </button>
                </Col>
              </Row>
            </div>
          </Card>
        )}

        <Row className="mt-3 mx-0">
          <Col>
            <div className="position-relative">
              <textarea
                rows="3"
                value={newComment}
                onChange={e => setNewComment(e.target.value)}
                className="form-control"
                placeholder="Enter Comment..."
                disabled={isSubmitting}
              />
              <div className="chat-input-links">
                <ul className="list-inline mb-0">
                  <li className="list-inline-item">
                    <label
                      htmlFor="imageInput"
                      style={{
                        color: "#556ee6",
                        fontSize: 20,
                        marginTop: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <i
                        className="mdi mdi-file-document-outline"
                        id="Filetooltip"
                      />
                      <UncontrolledTooltip placement="top" target="Filetooltip">
                        Add File
                      </UncontrolledTooltip>
                    </label>
                    <input
                      type="file"
                      id="imageInput"
                      className="d-none"
                      onChange={handleFileChange}
                    />
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col className="col-auto d-flex align-items-end">
            <Button
              type="button"
              color="primary"
              onClick={handleSubmitComment}
              className="btn btn-rounded chat-send w-md"
              disabled={(!newComment.trim() && !file) || isSubmitting}
            >
              <span className="d-none d-sm-inline-block me-2">
                {isSubmitting ? "Sending..." : "Send"}
              </span>
              <i className="mdi mdi-send" />
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default CPSComments
